import * as React from "react"
import PropTypes from "prop-types"
import { StaticImage } from "gatsby-plugin-image"

const Pros = () => (
  <>
    <section id="laxus-point">
      <h1>ラクサスが多くの人に愛される理由とは</h1>
      <div class="laxus-point-box">
        <StaticImage className="kv" alt="ご利用の流れ" src="../images/point-img-01.jpg" />
        <p class="point">point 1</p>
        <h2>ブランドバッグが期限なしで使い放題</h2>
        <p>エルメス・シャネル・セリーヌなど憧れのブランドバッグが無制限で使い放題。</p>
      </div>

      <div class="laxus-point-box">
        <StaticImage alt="step1画像" src="../images/point-img-02.jpg" />
        <p class="point">point 2</p>
        <h2>往復送料無料で<br />返却期限なし</h2>
        <p>お気に入りのバッグをずっと借りても、違うバッグに交換してもOK。<br />1ヶ月目でも、いつでも解約可能です。</p>
      </div>

      <div class="laxus-point-box">
        <StaticImage alt="step2_2画像" src="../images/point-img-03.jpg" />
        <p class="point">point 3</p>
        <h2>安心の<span class="pc_br"></span>キズ・汚れ補償</h2>
        <p>
          通常使いによる細かいキズや汚れは補償付きだから安心してご利用いただけます。
          <span>
          アプリ内のお困りごと、バッグについて不安や疑問がある場合は、いつでもアプリ内のトーク機能でお問い合わせいただけます。
          </span>
        </p>
      </div>
      <div class="laxus-point-box">
        <StaticImage alt="step2_2画像" src="../images/point-img-04.jpg" />
        <p class="point">point 4</p>
        <h2>品質管理が<span class="pc_br"></span>徹底されているから安心</h2>
        <p>ラクサスには鑑定士がいるので、本物のブランドバッグしか取り扱っていません。</p>
      </div>
    </section>
    <section id="bottom-app-dl">
      <div class="two-cloumn">
        <p>すでに220万人の方がダウンロードしています。</p>
        <a 
          className="dl__dl-item button link-adjust-dl"
          href="https://app.adjust.com/31tubmb"
          target="_blank"
          id="ui-btn-4-point"
          rel="noreferrer"
          data-adjust-ui-specific="ui-btn-4-point"
        >無料アプリをダウンロード</a>
        <a class="first_rental button" href="https://laxus.co/app/pc/info/howto">初めてのレンタルはこちら</a>        
      </div>
        <div class="two-cloumn-img">
          <StaticImage alt="アプリダウンロード" src="../images/app-dl-img.jpg" />
      </div>
    </section>
    <section id="for-the-earth">
      <div class="for-the-earth-img">
        <h1>地球のために<br />行動する</h1>
        <h2>ラクサスを活用して<br />環境に優しい暮らしを。</h2>
      </div>
      <div class="for-the-earth-note">
        <p>
          ラクサスを使う事は地球環境の保護に役立ちます。<br />
          毎年多くのバッグが焼却されています。<br />
          あなたがラクサスを使うと、<br />
          焼却されるバッグが一つ減ります。<br />
        </p>
        <p>
          所有から共有へ、廃棄から再利用へ、<br />
          あなたのエシカルな生き方が<br />
          サステナブル（持続可能）な社会を実現します。
        </p>
      </div>
    </section>
  </>
)

Pros.propTypes = {
  siteTitle: PropTypes.string,
}

Pros.defaultProps = {
  siteTitle: ``,
}

export default Pros
